import SkynetIcon from '../Fundamentals/SkynetIcon';
import { BankruptcyOperationStatus } from '../../Containers/BankruptcyTermination.types';

const OperationStatusBadge = ({ status }: { status: BankruptcyOperationStatus }) => {
    const iconMap: Record<BankruptcyOperationStatus, string> = {
        [BankruptcyOperationStatus.NotStarted]: 'vismaicon-time',
        [BankruptcyOperationStatus.Success]: 'vismaicon-success',
        [BankruptcyOperationStatus.Failed]: 'vismaicon-error',
        [BankruptcyOperationStatus.PartialSuccess]: 'vismaicon-warning',
        [BankruptcyOperationStatus.Skipped]: 'vismaicon-minus-circle',
    };
    return <SkynetIcon icon={iconMap[status]} title={BankruptcyOperationStatus[status]} filled />;
};

export default OperationStatusBadge;
